import React from "react";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import { Tabs, Tab } from "react-bootstrap";
import ProfileV1Setting from "../../components/Pages/ProfileV1Setting";
import UserImage from "../../assets/images/icon/profile.png";
import { Empty, notification, Skeleton, Tree } from "antd";
import AppContext from "../../components/AppContext";
import { removeSlashesFromPath } from "../../helpers/location/removeSlashesFromPath";
import { t } from "i18next";
import { withTranslation } from "react-i18next";
import { debounce } from "lodash";
import { getAllHeaderKeys, getViewTreeData } from "../../helpers/getTreeData";
import { CaretDownOutlined } from "@ant-design/icons";
class ProfileV1Page extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      isMobile: window.innerWidth <= 768,
      expandedKeys: [],
      profileData: {
        role: "",
        resProfile: "",
      },
    };
    this.debouncedFetch = debounce(this.fetchData, 100);
  }

  componentDidMount() {
    this.fetchData();
    window.addEventListener("resize", this.handleResize);

    if (this.context.setFetchProfileAdminCallback) {
      this.context.setFetchProfileAdminCallback(this.handleReload);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
    this.debouncedFetch.cancel();
  }
  onExpand = (expandedKeys) => this.setState({ expandedKeys });
  handleResize = () => {
    this.setState({ isMobile: window.innerWidth <= 768 });
  };

  handleReload = () => {
    const { fetchPromiseData } = this.context;

    this.setState({ isLoad: true }, async () => {
      await Promise.all([this.debouncedFetch(), fetchPromiseData()]);
    });
  };
  openNotification = (type, message, description) => {
    notification[type]({
      message: message,
      description: description,
      placement: "topRight",
    });
  };
  fetchData = async () => {
    this.setState({ loading: true });
    const { isPermissionAdmin, resProfileAdmin } = this.context;

    setTimeout(() => {
      const treeData = getViewTreeData(isPermissionAdmin, t);
      const allKeys = getAllHeaderKeys(treeData);

      this.setState({
        profileData: {
          permission: isPermissionAdmin,
          ...resProfileAdmin,
        },
        expandedKeys: allKeys, // กางออกทั้งหมดทันที
        loading: false,
      });
    }, 1000);
  };

  render() {
    const { profileData, loading, expandedKeys } = this.state;
    const { resProfileAdmin, isMerchantData } = this.context;
    // เตรียมข้อมูลสำหรับ Tree
    const permissions = profileData?.permission || [];
    const treeData = getViewTreeData(permissions, t);
    const checkedKeys = permissions.filter(p => p.isPublic === 1).map(p => p.id);
    return (
      <>
        <div
          style={{ flex: 1 }}
          onClick={() => {
            document.body.classList.remove("offcanvas-active");
          }}
        >
          <div>
            <div className="container-fluid">
              <PageHeader
                HeaderText={t("Profile")}
                Breadcrumb={[
                  {
                    name: removeSlashesFromPath(window.location.pathname),
                    navigate: window.location.pathname,
                  },
                ]}
              />
              <div className="row clearfix">
                <div className="col-lg-12">
                  <div className="card">
                    {loading ? (
                      <div className="p-3">
                        <Skeleton avatar paragraph={{ rows: 4 }} />
                      </div>
                    ) : (
                      <div className="body">
                        <Tabs
                          defaultActiveKey="Personnel"
                          id="uncontrolled-tab-example"
                        >
                          <Tab eventKey="Personnel" title={t("Personnel Info")}>
                            <ProfileV1Setting
                              openNotification={this.openNotification}
                              UserImage={UserImage}
                              profileData={profileData}
                              resProfileAdmin={resProfileAdmin}
                              isMerchantData={isMerchantData}
                              t={t}
                            />
                          </Tab>
                          <Tab
                            eventKey="Permission"
                            title={t("Permission Info")}
                          >
                            <div className="tab-pane" id="Permission">
                              <div className="body">
                                {!loading && (
                                  <div className="p-2 rounded-md ">
                                    {treeData.length === 0 ? (
                                      <Empty description={t("No permissions available.")} />
                                    ) : (
                                      <div className="scrollbar" >
                                        <Tree
                                          checkable
                                          selectable={false}
                                          treeData={treeData}
                                          checkedKeys={checkedKeys}
                                          expandedKeys={expandedKeys}
                                          onExpand={this.onExpand}
                                          switcherIcon={<CaretDownOutlined />}
                                          showLine={{ showLeafIcon: false }}
                                          showIcon
                                          blockNode
                                        />
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </Tab>
                        </Tabs>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = ({ ioTReducer }) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default connect(mapStateToProps, {})(withTranslation()(ProfileV1Page));
